import React from "react";
import ProjectCardImg from "../../assets/img/home/highest-test-img.png";
import { addTimeToDate, isoToString } from "../../utils/dateTool";
import { Link } from "react-router-dom";

const HighestProjectCard = ({ data }) => {
  let {
    _id,
    state,
    project_duration,
    publishedAt,
    title,
    amount_raised,
    abstract,
    category,
    token: currencyToken,
  } = data ?? {};
  return (
    <div className="w-[320px] h-[500px] p-3 rounded-2xl border border-[#7D7D9C] flex flex-col  font-roboto  hover:shadow-2xl transition-all duration-300 text-white">
      {/* ///// project image ////// */}
      <div className=" rounded-2xl relative flex justify-center items-center">
        <div className="w-[90%] flex items-center justify-around mt-10 absolute highest-project-card-gradient-box text-black py-2 px-3 bottom-3">
          <div className="flex flex-col items-center">
            <span className="text-[10px]">Amount raised</span>
            <span className="font-medium mt-1">
              {Number(amount_raised.toFixed(4))} {currencyToken}
            </span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-[10px]">Ends in</span>
            <span className="font-medium mt-1">
              {isoToString(
                addTimeToDate({
                  date: publishedAt,
                  milliseconds: project_duration,
                })
              )}
            </span>
          </div>
        </div>
        <img
          src={abstract || ProjectCardImg}
          // src={ProjectCardImg}
          alt="ProjectCardImg"
          className=" w-full h-[280px] rounded-xl object-cover"
        />
        <span className="absolute left-0 top-4 rounded-r-2xl bg-primary text-sm text-white px-2 py-1">
          {state}
        </span>
      </div>
      {/* ///// project detail ////// */}

      <div className="w-full h-full flex flex-col justify-between px-1 text-left">
        <span className="flex flex-col ml-2  mt-6 w-full">
          <span className="font-medium ">
            {title.slice(0, 30)}
            {title?.length > 30 ? "..." : ""}
          </span>
          <span className=" text-[#CDCDCD] text-sm ">{category}</span>
        </span>

        {/* /////////// */}
        <Link
          to={`/projects/${_id}`}
          className="w-full mr-3 mt-5 text-white flex justify-center items-center bg-light-primary  py-2 rounded-[10px] overflow-hidden "
        >
          See Project
        </Link>
      </div>
    </div>
  );
};

export default HighestProjectCard;
